import { returnAndNotify } from "common/api/with-notifications";
import { ApiCall, Crud } from "common/types/api";
import { Filter } from "common/types/filters";
import { CancellablePromise } from "common/types/promises";

export type SearchParams = {
  entity: string;
  name: string;
  sites: string[];
  roleIds: number[];
};

interface FilterApiType extends Crud<number, Filter> {
  listForEntity: (
    entityName: string,
    site?: string,
  ) => CancellablePromise<Filter[]>;
  sharedList: (
    page: number,
    pageSize: number,
    searchParams?: SearchParams,
  ) => CancellablePromise<{ filters: Filter[]; fullCount: number }>;
  isNameUnique: (name: string, id?: number) => CancellablePromise<boolean>;
}

export const filtersApi = (apiCall: ApiCall): FilterApiType => ({
  get: (id: number) => apiCall("get", `api/ui/filters/${id}`),
  list: () => apiCall("get", `api/ui/filters`),
  create: (filter: Filter) =>
    apiCall("post", "api/ui/filters", filter).then(
      returnAndNotify(_("The view was successfully created")),
    ),
  update: (filter: Filter) =>
    apiCall("put", `api/ui/filters/${filter.id}`, filter).then(
      returnAndNotify(_("The view was successfully updated")),
    ),
  remove: (id: number) =>
    apiCall("delete", `api/ui/filters/${id}`).then(
      returnAndNotify(_("The view was successfully deleted")),
    ),
  listForEntity: (entityName: string, site?: string) => {
    const url = !site
      ? `api/ui/filters/${entityName}`
      : `api/ui/filters/${entityName}?site=${site}`;
    return apiCall<Filter[]>("get", url);
  },
  sharedList: (page: number, pageSize: number, searchParams?: SearchParams) =>
    apiCall<{ filters: Filter[]; fullCount: number }>(
      "post",
      "api/ui/filters/shared",
      {
        ...searchParams,
        page,
        pageSize,
      },
    ),
  isNameUnique: (name: string, id?: number) => {
    const idParameter = id ? `&id=${id}` : "";
    return apiCall<boolean>(
      "get",
      `api/ui/filters/check-unique-name?name=${name}${idParameter}`,
    );
  },
});
